export enum OrganizationTypes {
    TNF = "DOCKS-TNF",
    ALG = "DOCKS-ALG",
    VLC = "DOCKS-VLC",
    SAG = "DOCKS-SAG",
}
